import React, { type PropsWithChildren, type ErrorInfo, type ComponentType } from 'react';
import { BaseInvitePeopleAnalytics, useAnalytics } from '../../analytics';
import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseErrorBoundary } from '../../components/ErrorBoundary/BaseErrorBoundary';

class CollectionsErrorBoundaryAnalytics extends BaseInvitePeopleAnalytics {
	errorBoundaryRendered(attributes: { error: { message: string; stack: string | undefined } }) {
		const { productTitle, source, subProduct } = this.commonAttributes;
		this.fireOperational({
			action: AnalyticsAction.RENDERED,
			actionSubject: AnalyticsActionSubject.ERROR_BOUNDARY,
			actionSubjectId: 'twcForCoreInvites',
			attributes: {
				product: productTitle,
				source,
				subProduct,
				...attributes,
			},
		});
	}
}

interface CollectionsErrorBoundaryProps extends PropsWithChildren {
	fallback: ComponentType;
}

export const CollectionsErrorBoundary = ({
	children,
	fallback,
}: CollectionsErrorBoundaryProps): React.JSX.Element => {
	const analytics = useAnalytics(CollectionsErrorBoundaryAnalytics);

	const onError = (error: Error, info?: ErrorInfo) => {
		analytics.errorBoundaryRendered({
			error: {
				message: error.message,
				stack: info?.componentStack || error.stack,
			},
		});
	};

	return (
		<BaseErrorBoundary ErrorComponent={fallback} onError={onError}>
			{children}
		</BaseErrorBoundary>
	);
};
